import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import HorizontalDivider from '../HorizontalDivider';
import css from './Accordion.module.scss';

export interface AccordionItem {
  label: string;
  content: JSX.Element;
  active?: boolean;
}

interface AccordionProps {
  items: AccordionItem[];
}

export default function Accordion({ items }: AccordionProps) {
  const [accordionItems, setAccordionItems] = useState<AccordionItem[]>(items);

  useEffect(() => {
    setAccordionItems(items);
  }, [items]);

  return (
    <>
      {items.map((item, idx) => {
        return (
          <div key={`${item.label}_${item.content}_${idx}`}>
            <div
              className={css.labelContainer}
              onClick={() => {
                const newState = { ...accordionItems };
                newState[idx].active = !newState[idx].active;
                setAccordionItems(newState);
              }}
            >
              <span className={css.labelText}>{item.label}</span>
              <img
                src="/static/caret.svg"
                className={cx(css.caret, { [css.rotate]: item.active })}
              />
            </div>
            <div
              className={cx(
                css.itemContent,
                { [css.hidden]: !item.active },
                { [css.active]: item.active }
              )}
            >
              {item.content}
            </div>
            <HorizontalDivider />
          </div>
        );
      })}
    </>
  );
}
